export default "__VITE_ASSET__6UvhvR2f__"